<template>
    <div class="chargingPrice-config-box">
        <div class="head">
            <div class="op-box">
                <el-button size="mini" type="primary" @click="add" icon="el-icon-plus">添加</el-button>
                <el-button size="mini" style="color: #E6A23C" type="text" @click="edit"><i><svg-icon style="width:1.2em; height: 1.2em; padding-left: 1rem" icon-class="修改"></svg-icon></i>&nbsp;修改</el-button>
                <el-button size="mini" style="color: #F56C6C" type="text" @click="remove"><i><svg-icon style="width:1.2em; height: 1.2em; padding-left: 1rem" icon-class="停用"></svg-icon></i>&nbsp;删除</el-button>
            </div>
        </div>

        <div class="chargingPrice-config-table-box">
            <el-table class="charging-Price-Table" :data="chargingPrices" height="100%" width="100%" @row-click="rowClick" :header-row-style="{color:'black'}"
                      size="small" highlight-current-row>
                <el-table-column
                        align="center"
                        prop="name"
                        label="计费价格名称"
                        width="280">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="code"
                        label="计费价格编码">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="customerEnergyId"
                        label="能源类型">
                    <template slot-scope="scope">
                        <span>{{ scope.row.customerEnergyId == '480d65f3-a47e-427c-b649-b3d179b3c0e2' ? '电': '水' }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="价格类型">
                    <template slot-scope="scope">
                        <span>{{ scope.row.singlePrice === null ? '分时价格': '单一价格' }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="singlePrice"
                        label="价格（元）">
                    <template slot-scope="scope">
                        <template v-if="isNumber(scope.row.singlePrice)">
                            <span>{{ numberFormat4(scope.row.singlePrice) }}</span>
                        </template>
                        <template v-else>
                            <el-button type="text" @click="detailView(scope.row)">查看详情</el-button>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="startDate"
                        label="启用时间">
                    <template slot-scope="scope">
                        <span>{{ formatTime(scope.row.startDate) }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="note"
                        label="备注">
                </el-table-column>
            </el-table>
        </div>
        <div class="chargingPrice-config-page-box">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.current"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.total">
            </el-pagination>
        </div>

        <el-dialog :visible.sync="dialogVisible" width="37.5rem" top="15vh" size="small">
            <template slot="title">
                {{ typeof selectedChargingPrice.id === 'undefined' || selectedChargingPrice.id === null || selectedChargingPrice.id === '' ? '添加': '编辑'}}计费价格
            </template>

            <div style="display: flex; justify-content: center">
                <el-form ref="form" :model="selectedChargingPrice" :rules="rules" label-width="7.5rem" size="small">
                    <div class="item-group">
                        <el-form-item label="计费价格名称" prop="name" >
                            <el-input v-model.trim="selectedChargingPrice.name"></el-input>
                        </el-form-item>
                        <el-form-item label="计费价格编码" prop="code">
                            <el-input v-model.trim="selectedChargingPrice.code"></el-input>
                        </el-form-item>
                    </div>

                    <div class="item-group">
                        <el-form-item label="能源类型" prop="customerEnergyId">
                            <el-select v-model="selectedChargingPrice.customerEnergyId" placeholder="请选择">
                                <el-option v-for="customerEnergy in customerEnergies" :key="customerEnergy.id"
                                           :label="customerEnergy.name" :value="customerEnergy.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="启用时间" prop="startDate">
                            <el-date-picker
                                    v-model="selectedChargingPrice.startDate"
                                    type="datetime"
                                    placeholder="选择时间">
                            </el-date-picker>
                        </el-form-item>
                    </div>

                    <div class="item-group">
                        <el-form-item label="计费价格类型" prop="type">
                            <el-select v-model="selectedChargingPrice.type" placeholder="计费价格类型">
                                <el-option label="单一价格" :value=1></el-option>
                                <el-option label="分时价格" :value=0 :disabled="selectedChargingPrice.customerEnergyId === '16396ef1-06a1-4896-a3d6-6c3eb17df360'"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="text" @click="modifySettings" :disabled="selectedChargingPrice.customerEnergyId === '16396ef1-06a1-4896-a3d6-6c3eb17df360'">分时费率价格设置修改</el-button>
                        </el-form-item>
                        <el-form-item label="单一价格" prop="singlePrice">
                            <el-input v-model="selectedChargingPrice.singlePrice" placeholder="0-10，支持到小数点后4位"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item label="备注" prop="note">
                        <el-input type="textarea"  v-model="selectedChargingPrice.note"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click="save" size="small">保存</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="detailDialogVisible" width="80rem" top="15vh" size="small">
            <template slot="title">
                {{ typeof selectedChargingPrice.id === 'undefined' || selectedChargingPrice.id === null || selectedChargingPrice.id === '' ? '分时费率价格设置添加': '分时费率价格设置修改'}}
            </template>

            <div style="max-height: 32rem; overflow: auto">
                <div style="display: flex; justify-content: center">
                    <el-container>
                        <el-header style="height: auto">费率设置</el-header>
                        <el-main>
                            <el-form ref="rateForm" :model="rate" label-width="6.875rem" size="small" :inline="true">
                                <el-row v-for="(rate,index) in rates" :key="index">
                                    <el-form-item label="" prop="name" >
                                        <el-input v-model="rate.name" size="mini" :readonly=true></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="price">
                                        <el-input v-model.trim="rate.price" size="mini" placeholder="0-10，支持到小数点后4位" @change="validatePrice(rate.price)"><template slot="suffix">元</template></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="note">
                                        <el-input v-model.trim="rate.note" size="mini" placeholder="备注"></el-input>
                                    </el-form-item>
                                    <template v-if="rates.length === 1 ">
                                        <el-button @click="rateAdd" size="small" circle icon="el-icon-plus"></el-button>
                                    </template>
                                    <template v-else>
                                        <el-button @click="rateAdd" size="small" circle icon="el-icon-plus"></el-button>
                                        <el-button type="info" @click="rateRemove" size="small" circle icon="el-icon-minus"></el-button>
                                    </template>
                                </el-row>
                            </el-form>
                        </el-main>
                    </el-container>
                </div>
                <div style="display: flex; justify-content: center">
                    <el-container>
                        <el-header style="height: auto">日时段设置</el-header>
                        <el-main>
                            <div v-for="(dailySchedules,index) in dailySchedulesArr" :key="index">
                                <el-form ref="dailyScheduleForm" :inline="true"
                                         :model="dailySchedule" label-width="6.875rem" size="small">
                                    <el-row v-for="(dailySchedule,num) in dailySchedulesArr[index]" :key="num" style="width: 92%;float: left">
                                        <el-form-item label="" prop="name" >
                                            <el-input v-model="dailySchedule.name" size="mini" :readonly=true></el-input>
                                        </el-form-item>
                                        <el-form-item label="" prop="startDate" >
                                            <el-time-picker v-model="dailySchedule.startDate" placeholder="开始时间" size="mini" @change="startTimeSetting(index,num)" format="HH:mm"></el-time-picker>
                                        </el-form-item>
                                        <el-form-item label="" prop="endDate" >
                                            <el-time-picker v-model="dailySchedule.endDate" placeholder="结束时间" size="mini" @change="endTimeSetting(index,num)" format="HH:mm"></el-time-picker>
                                        </el-form-item>
                                        <el-form-item label="" prop="rateId" >
                                            <el-select v-model="dailySchedule.rateId" placeholder="请选择费率" size="mini">
                                                <el-option v-for="rate in rates" :key="rate.id"
                                                           :label="rate.name" :value="rate.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <template v-if="dailySchedules.length === 1 ">
                                            <el-button @click="dailyScheduleAdd(index)" size="small" circle icon="el-icon-plus"></el-button>
                                        </template>
                                        <template v-else>
                                            <el-button @click="dailyScheduleAdd(index)" size="small" circle icon="el-icon-plus"></el-button>
                                            <el-button type="info" @click="dailyScheduleRemove(index)" size="small" circle icon="el-icon-minus"></el-button>
                                        </template>
                                    </el-row>
                                    <el-row style="width: 8%;float: right">
                                        <template v-if="dailySchedulesArr.length === 1 ">
                                            <el-button @click="dailySchedulesAdd" size="small" circle icon="el-icon-plus"></el-button>
                                        </template>
                                        <template v-else>
                                            <el-button @click="dailySchedulesAdd" size="small" circle icon="el-icon-plus"></el-button>
                                            <el-button type="info" @click="dailySchedulesRemove" size="small" circle icon="el-icon-minus"></el-button>
                                        </template>
                                    </el-row>
                                </el-form>
                            </div>
                        </el-main>
                    </el-container>
                </div>
                <div style="display: flex; justify-content: center">
                    <el-container>
                        <el-header style="height: auto">年时区设置</el-header>
                        <el-main>
                            <el-form ref="yearRangeForm" :inline="true" :model="yearRange" label-width="6.875rem" size="small">
                                <el-row v-for="(yearRange,no) in yearRanges" :key="no" style="width: 92%;float: left">
                                    <el-form-item label="" prop="name" >
                                        <el-input v-model.trim="yearRange.name" size="mini" :readonly=true></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="startDate">
                                        <el-date-picker v-model="yearRange.startDate" placeholder="开始时间" size="mini" @change="startDateSetting(no)" format="MM-dd"></el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="" prop="endDate" >
                                        <el-date-picker v-model="yearRange.endDate" placeholder="结束时间" size="mini" @change="endDateSetting(no)" format="MM-dd"></el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="" prop="dailyScheduleId" >
                                        <el-select v-model="yearRange.dailyScheduleId" placeholder="请选择日时段" size="mini">
                                            <el-option v-for="dailySchedule in dailySchedulesCache" :key="dailySchedule.dailyScheduleId"
                                                       :label="dailySchedule.name" :value="dailySchedule.dailyScheduleId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <template v-if="yearRanges.length === 1 ">
                                        <el-button @click="yearRangeAdd(no)" size="small" circle icon="el-icon-plus"></el-button>
                                    </template>
                                    <template v-else>
                                        <el-button @click="yearRangeAdd(no)" size="small" circle icon="el-icon-plus"></el-button>
                                        <el-button type="info" @click="yearRangeRemove(no)" size="small" circle icon="el-icon-minus"></el-button>
                                    </template>
                                </el-row>
                            </el-form>
                        </el-main>
                    </el-container>
                </div>
                <div style="display: flex; justify-content: center">
                    <el-container>
                        <el-header style="height: auto">周休设置</el-header>
                        <el-main>
                            <el-button @click="weekendAdd(-1)" size="small" circle icon="el-icon-plus"></el-button>
                            <el-form ref="weekendForm" :inline="true" :model="weekend" label-width="6.875rem" size="small">
                                <el-row v-for="(weekend,j) in weekends" :key="j" style="width: 92%;float: left">
                                    <el-form-item label="" prop="name" >
                                        <el-input v-model.trim="weekend.name" size="mini" :readonly=true></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="dayOfWeek" >
                                        <el-select v-model="weekend.dayOfWeek" placeholder="请选择" size="mini">
                                            <el-option label="星期一" :value="1"></el-option>
                                            <el-option label="星期二" :value="2"></el-option>
                                            <el-option label="星期三" :value="3"></el-option>
                                            <el-option label="星期四" :value="4"></el-option>
                                            <el-option label="星期五" :value="5"></el-option>
                                            <el-option label="星期六" :value="6"></el-option>
                                            <el-option label="星期日" :value="7"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="" prop="dailyScheduleId" >
                                        <el-select v-model="weekend.dailyScheduleId" placeholder="请选择日时段" size="mini">
                                            <el-option v-for="dailySchedule in dailySchedulesCache" :key="dailySchedule.dailyScheduleId"
                                                       :label="dailySchedule.name" :value="dailySchedule.dailyScheduleId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-button @click="weekendAdd(j)" size="small" circle icon="el-icon-plus"></el-button>
                                    <el-button type="info" @click="weekendRemove(j)" size="small" circle icon="el-icon-minus"></el-button>
                                </el-row>
                            </el-form>
                        </el-main>
                    </el-container>
                </div>
                <div style="display: flex; justify-content: center">
                    <el-container>
                        <el-header style="height: auto">节假日设置</el-header>
                        <el-main>
                            <el-button @click="holidayAdd(-1)" size="small" circle icon="el-icon-plus"></el-button>
                            <el-form ref="holidayForm" :inline="true" :model="holiday" label-width="6.875rem" size="small">
                                <el-row v-for="(holiday,k) in holidays" :key="k" style="width: 92%;float: left">
                                    <el-form-item label="" prop="name" >
                                        <el-input v-model.trim="holiday.name" size="mini" :readonly=true></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="date" >
                                        <el-date-picker v-model="holiday.date" placeholder="选择日期" size="mini" format="MM-dd"></el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="" prop="dailyScheduleId" >
                                        <el-select v-model="holiday.dailyScheduleId" placeholder="请选择日时段" size="mini">
                                            <el-option v-for="dailySchedule in dailySchedulesCache" :key="dailySchedule.dailyScheduleId"
                                                       :label="dailySchedule.name" :value="dailySchedule.dailyScheduleId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-button @click="holidayAdd(k)" size="small" circle icon="el-icon-plus"></el-button>
                                    <el-button type="info" @click="holidayRemove(k)" size="small" circle icon="el-icon-minus"></el-button>
                                </el-row>
                            </el-form>
                        </el-main>
                    </el-container>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <!--<el-button @click="detailDialogVisible = false" size="small">取消</el-button>-->
                <el-button type="primary" @click="chargingConfirm" size="small">确定</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="viewDialogVisible" width="70rem" top="15vh" size="small">
            <template slot="title">
                计费价格详情
            </template>
            <div style="max-height: 32rem; overflow: auto">
                <div style="display: flex; justify-content: center">
                    <el-container>
                        <el-header style="height: auto">费率设置</el-header>
                        <el-main>
                            <el-form ref="rateForm1" :model="rate" label-width="6.875rem" size="small" :inline="true">
                                <el-row v-for="(rate,index) in rates" :key="index">
                                    <el-form-item label="" prop="name" >
                                        <el-input v-model.trim="rate.name" size="mini" :readonly=true></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="price">
                                        <el-input v-model.trim="rate.price" size="mini" placeholder="0-10，支持到小数点后4位" :readonly=true><template slot="suffix">元</template></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="note">
                                        <el-input v-model.trim="rate.note" size="mini" placeholder="备注" :readonly=true></el-input>
                                    </el-form-item>
                                </el-row>
                            </el-form>
                        </el-main>
                    </el-container>
                </div>
                <div style="display: flex; justify-content: center">
                    <el-container>
                        <el-header style="height: auto">日时段设置</el-header>
                        <el-main>
                            <div v-for="(dailySchedules,index) in dailySchedulesArr" :key="index">
                                <el-form ref="dailyScheduleForm1" :inline="true" :model="dailySchedule" label-width="6.875rem" size="small">
                                    <el-row v-for="(dailySchedule,num) in dailySchedulesArr[index]" :key="num" style="width: 92%;float: left">
                                        <el-form-item label="" prop="name" >
                                            <el-input v-model.trim="dailySchedule.name" size="mini" :readonly=true></el-input>
                                        </el-form-item>
                                        <el-form-item label="" prop="startDate" >
                                            <el-time-picker v-model="dailySchedule.startDate" placeholder="开始时间" size="mini" format="HH:mm" :readonly=true></el-time-picker>
                                        </el-form-item>
                                        <el-form-item label="" prop="endDate" >
                                            <el-time-picker v-model="dailySchedule.endDate" placeholder="结束时间" size="mini" format="HH:mm" :readonly=true></el-time-picker>
                                        </el-form-item>
                                        <el-form-item label="" prop="rateId" >
                                            <el-select v-model="dailySchedule.rateId" placeholder="请选择" size="mini" disabled=true>
                                                <el-option v-for="rate in rates" :key="rate.id"
                                                           :label="rate.name" :value="rate.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                            </div>
                        </el-main>
                    </el-container>
                </div>
                <div style="display: flex; justify-content: center">
                    <el-container>
                        <el-header style="height: auto">年时区设置</el-header>
                        <el-main>
                            <el-form ref="yearRangeForm1" :inline="true" :model="yearRange" label-width="6.875rem" size="small">
                                <el-row v-for="(yearRange,index) in yearRanges" :key="index" style="width: 92%;float: left">
                                    <el-form-item label="" prop="name" >
                                        <el-input v-model.trim="yearRange.name" size="mini" :readonly=true></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="startDate">
                                        <el-date-picker v-model="yearRange.startDate" placeholder="开始时间" size="mini" format="MM-dd" :readonly=true></el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="" prop="endDate" >
                                        <el-date-picker v-model="yearRange.endDate" placeholder="结束时间" size="mini" format="MM-dd" :readonly=true></el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="" prop="dailyScheduleId" >
                                        <el-select v-model="yearRange.dailyScheduleId" placeholder="请选择" size="mini" disabled=true>
                                            <el-option v-for="dailySchedule in dailySchedulesCache" :key="dailySchedule.dailyScheduleId"
                                                       :label="dailySchedule.name" :value="dailySchedule.dailyScheduleId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-row>
                            </el-form>
                        </el-main>
                    </el-container>
                </div>
                <div style="display: flex; justify-content: center">
                    <el-container>
                        <el-header style="height: auto">周休设置</el-header>
                        <el-main>
                            <el-form :inline="true" :model="weekend" label-width="6.875rem" size="small">
                                <el-row v-for="(weekend,index) in weekends" :key="index" style="width: 92%;float: left">
                                    <el-form-item label="" prop="name" >
                                        <el-input v-model.trim="weekend.name" size="mini" :readonly=true ></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="dayOfWeek" >
                                        <el-select v-model="weekend.dayOfWeek" placeholder="请选择" size="mini" disabled=true>
                                            <el-option label="星期一" :value="1"></el-option>
                                            <el-option label="星期二" :value="2"></el-option>
                                            <el-option label="星期三" :value="3"></el-option>
                                            <el-option label="星期四" :value="4"></el-option>
                                            <el-option label="星期五" :value="5"></el-option>
                                            <el-option label="星期六" :value="6"></el-option>
                                            <el-option label="星期日" :value="7"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="" prop="dailyScheduleId" >
                                        <el-select v-model="weekend.dailyScheduleId" placeholder="请选择" size="mini" disabled=true>
                                            <el-option v-for="dailySchedule in dailySchedulesCache" :key="dailySchedule.dailyScheduleId"
                                                       :label="dailySchedule.name" :value="dailySchedule.dailyScheduleId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-row>
                            </el-form>
                        </el-main>
                    </el-container>
                </div>
                <div style="display: flex; justify-content: center">
                    <el-container>
                        <el-header style="height: auto">节假日设置</el-header>
                        <el-main>
                            <el-form :inline="true" :model="holiday" label-width="6.875rem" size="small">
                                <el-row v-for="(holiday,index) in holidays" :key="index" style="width: 92%;float: left">
                                    <el-form-item label="" prop="name" >
                                        <el-input v-model.trim="holiday.name" size="mini" :readonly=true></el-input>
                                    </el-form-item>
                                    <el-form-item label="" prop="date" >
                                        <el-date-picker v-model="holiday.date" placeholder="选择日期" size="mini" format="MM-dd" :readonly=true></el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="" prop="dailyScheduleId" >
                                        <el-select v-model="holiday.dailyScheduleId" placeholder="请选择" size="mini" disabled=true>
                                            <el-option v-for="dailySchedule in dailySchedulesCache" :key="dailySchedule.dailyScheduleId"
                                                       :label="dailySchedule.name" :value="dailySchedule.dailyScheduleId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-row>
                            </el-form>
                        </el-main>
                    </el-container>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="removeDialogVisible" width="34.375rem" top="15vh" size="small">
            <template slot="title">
                删除提示
            </template>
            <div style="display: flex; justify-content: center">
                删除后数据不可恢复！谨慎删除！
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="removeDialogVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click="deleteChargingPrice" size="small">确认</el-button>
              </span>
        </el-dialog>
    </div>



</template>

<script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { getChargingPrice, save, verifyChargingPrice, remove, detailSave } from  '@/api/ChargingPrice'
  import { getCurrDayZero, getCurrDayLast, formatToSecond, getYearStartDate, getYearEndDate } from '@/utils/time'
  import { tenantId,electricityId,waterId } from '@/config/config'
  import { identifierRegex, mobileRegex, emailRegex, chargingRegex } from '@/utils/validate'
  import { getCustomerEenrgies } from "@/api/customerEnergy";
  import { uuidWithoutLine } from "@/utils/uuid";

  export default {
    name: 'chargingPriceConfig',
    data() {
      return {
        loading:true,
        page: {}, /* 分页对象*/
        currentPage: 1,
        pagesize: 10,
        chargingPrices: [],
        customerEnergies: [],
        condition: {
          customerId:null
        },
        selectedChargingPrice: {},
        rules: {
          name: [{ required: true, message: '名称必填', trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }],
          code: [{ required: true, pattern: identifierRegex, message: '请输入正确的编码', trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }],
          customerEnergyId: [{ required: true, message: '能源类型必选', trigger: 'change' }],
          type: [{ required: true, message: '计费价格类型必选', trigger: 'change' }],
          startDate: [{ required: true, message: '启用时间必填', trigger: 'blur' }],
          singlePrice: [{ pattern: chargingRegex, message: '请输入正确的费率', trigger: 'blur' }]
        },
        dialogVisible: false,
        rate: {},
        rates: [],
        dailySchedule: {},
        dailySchedulesArr: [],
        dailySchedulesCache: [],
        yearRange: {},
        yearRanges: [],
        weekend: {},
        weekends: [],
        holiday: {},
        holidays: [],
        detailDialogVisible: false,
        viewDialogVisible: false,
        removeDialogVisible: false
      }
    },
    computed: {
      ...mapGetters([
        'customerId'
      ])
    },
    mounted() { /* 页面初始化完成加载数据*/
      this.page.size = 10
      this.fetchChargingPrice()
      this.fetchCustomerEnergies()
    },
    methods: {
      validatePrice: function(value){
        if(!chargingRegex.test(value)){
          Message({
            message: '请输入正确的费率',
            type: 'warning',
            duration: 5 * 1000
          })
        }
      },
      fetchChargingPrice() { /* 查询*/
        if (this.page.total) this.page.total = null
        this.condition.customerId = this.customerId
        const myPage = { page: this.page, condition: this.condition }
        getChargingPrice(myPage).then(res => {
          let data = res.infoJson
          this.page.total = data.total
          this.page.current = data.current
          this.page.size = data.size
          this.page.pages = data.pages
          this.chargingPrices = data.records
        }).catch(error => {
          console.log(error)
        })
      },
      fetchCustomerEnergies: function () {
        var customerId = this.customerId
        getCustomerEenrgies(customerId).then(res => {
          if(res.code === 200){
            this.customerEnergies =  res.infoJson
          }
        })
      },
      rowClick(val){
        this.selectedChargingPrice = Object.assign({}, val)//获取选中行对象信息
      },
      modifySettings: function(){
        //重置
        this.rates = []
        this.dailySchedulesCache = []
        this.dailySchedulesArr = []
        this.yearRanges = []
        this.weekends = []
        this.holidays = []
        //获取年时区、节假日、周休日中的日时段信息（去重）
        var nameAndIds = [];//去重用
        var dailSchedulesTemp = [];
        if(this.selectedChargingPrice.yearRanges.length>0){
          for(var i = 0; i < this.selectedChargingPrice.yearRanges.length; i ++){
            if(this.selectedChargingPrice.yearRanges[i].dailySchedules.length > 0){
              for(var j = 0; j < this.selectedChargingPrice.yearRanges[i].dailySchedules.length; j ++){
                if(nameAndIds.indexOf(this.selectedChargingPrice.yearRanges[i].dailySchedules[j].name+','+
                  this.selectedChargingPrice.yearRanges[i].dailySchedules[j].id) === -1){
                  nameAndIds.push(this.selectedChargingPrice.yearRanges[i].dailySchedules[j].name+','+
                    this.selectedChargingPrice.yearRanges[i].dailySchedules[j].id)
                  dailSchedulesTemp.push(this.selectedChargingPrice.yearRanges[i].dailySchedules[j])
                }
              }
            }
          }
        }
        if(this.selectedChargingPrice.weekends.length>0){
          for(var i = 0; i < this.selectedChargingPrice.weekends.length; i ++){
            if(this.selectedChargingPrice.weekends[i].dailySchedules.length > 0){
              for(var j = 0; j < this.selectedChargingPrice.weekends[i].dailySchedules.length; j ++){
                if(nameAndIds.indexOf(this.selectedChargingPrice.weekends[i].dailySchedules[j].name+','+
                  this.selectedChargingPrice.weekends[i].dailySchedules[j].id) === -1){
                  nameAndIds.push(this.selectedChargingPrice.weekends[i].dailySchedules[j].name+','+
                    this.selectedChargingPrice.weekends[i].dailySchedules[j].id)
                  dailSchedulesTemp.push(this.selectedChargingPrice.weekends[i].dailySchedules[j])
                }
              }
            }
          }
        }
        if(this.selectedChargingPrice.holidays.length>0){
          for(var i = 0; i < this.selectedChargingPrice.holidays.length; i ++){
            if(this.selectedChargingPrice.holidays[i].dailySchedules.length > 0){
              for(var j = 0; j < this.selectedChargingPrice.holidays[i].dailySchedules.length; j ++){
                if(nameAndIds.indexOf(this.selectedChargingPrice.holidays[i].dailySchedules[j].name+','+
                  this.selectedChargingPrice.holidays[i].dailySchedules[j].id) === -1){
                  nameAndIds.push(this.selectedChargingPrice.holidays[i].dailySchedules[j].name+','+
                    this.selectedChargingPrice.holidays[i].dailySchedules[j].id)
                  dailSchedulesTemp.push(this.selectedChargingPrice.holidays[i].dailySchedules[j])
                }
              }
            }
          }
        }
        //划分日时段
        var names = [];
        if(nameAndIds.length > 0){
          for(var i = 0; i < nameAndIds.length; i ++){
            if(names.indexOf(nameAndIds[i].split(',')[0]) === -1){
              names.push(nameAndIds[i].split(',')[0])
            }
          }
        }
        var dailySchedulesArrTemp = []
        if(names.length > 0){
          for(var i = 0; i < names.length; i ++){
            if(dailSchedulesTemp.length > 0){
              var dailySchedulesTmep1 = []
              for(var j = 0; j < dailSchedulesTemp.length; j ++){
                if(dailSchedulesTemp[j].name === names[i]){
                  dailySchedulesTmep1.push(dailSchedulesTemp[j])
                }
              }
              dailySchedulesArrTemp.push(dailySchedulesTmep1)
            }
          }
        }
        //获取日时段中所有的基本费率信息（去重）
        var rateIds = []//去重用
        var ratesTemp = []
        if(dailSchedulesTemp.length > 0){
          for(var j = 0; j < dailSchedulesTemp.length; j ++){
            if(dailSchedulesTemp[j].rates.length > 0){
              for(var i = 0 ; i < dailSchedulesTemp[j].rates.length; i ++){
                if(rateIds.indexOf(dailSchedulesTemp[j].rates[i].id) === -1){
                  rateIds.push(dailSchedulesTemp[j].rates[i].id)
                  ratesTemp.push(dailSchedulesTemp[j].rates[i])
                }
              }
            }
          }
        }
        //划分日时段缓存
        var dscIds = []
        var dailySchedulesCacheTemp = []
        if(dailSchedulesTemp.length>0){
          for(var i = 0; i < dailSchedulesTemp.length; i ++){
            if(this.selectedChargingPrice.yearRanges.length>0){
              for(var j = 0; j < this.selectedChargingPrice.yearRanges.length; j ++){
                if(this.selectedChargingPrice.yearRanges[j].dailyScheduleId === dailSchedulesTemp[i].dailyScheduleId){
                  if(dscIds.indexOf(this.selectedChargingPrice.yearRanges[j].dailyScheduleId) === -1){
                    dscIds.push(this.selectedChargingPrice.yearRanges[j].dailyScheduleId)
                    dailySchedulesCacheTemp.push(dailSchedulesTemp[i])
                  }
                }
              }
            }
            if(this.selectedChargingPrice.weekends.length>0){
              for(var j = 0; j < this.selectedChargingPrice.weekends.length; j ++){
                for(var k = 0; k < this.selectedChargingPrice.weekends[j].dailySchedules.length; k ++){
                  if(this.selectedChargingPrice.weekends[j].dailyScheduleId === dailSchedulesTemp[i].dailyScheduleId){
                    if(dscIds.indexOf(this.selectedChargingPrice.weekends[j].dailyScheduleId) === -1){
                      dscIds.push(this.selectedChargingPrice.weekends[j].dailyScheduleId)
                      dailySchedulesCacheTemp.push(dailSchedulesTemp[i])
                    }
                  }
                }
              }
            }
            if(this.selectedChargingPrice.holidays.length>0){
              for(var j = 0; j < this.selectedChargingPrice.holidays.length; j ++){
                for(var k = 0; k < this.selectedChargingPrice.holidays[j].dailySchedules.length; k ++){
                  if(this.selectedChargingPrice.holidays[j].dailyScheduleId === dailSchedulesTemp[i].dailyScheduleId){
                    if(dscIds.indexOf(this.selectedChargingPrice.holidays[j].dailyScheduleId) === -1){
                      dscIds.push(this.selectedChargingPrice.holidays[j].dailyScheduleId)
                      dailySchedulesCacheTemp.push(dailSchedulesTemp[i])
                    }
                  }
                }
              }
            }
          }
        }
        //修改信息预填
        this.rates = ratesTemp
        this.dailySchedulesCache = dailySchedulesCacheTemp
        this.dailySchedulesArr = dailySchedulesArrTemp
        this.yearRanges = this.selectedChargingPrice.yearRanges
        this.weekends = this.selectedChargingPrice.weekends
        this.holidays = this.selectedChargingPrice.holidays
        //添加
        if(this.rates.length === 0){
          var rate = {
            id: uuidWithoutLine(),
            customerId: this.customerId,
            name: "费率1",
            price: null,
            sort: 1,
            chargingPriceId: this.selectedChargingPrice.id,
            note: null
          }
          this.rate = rate
          this.rates.push(rate)
        }
        if(this.dailySchedulesArr.length === 0) {
          var dailySchedule = {
            id: uuidWithoutLine(),
            dailyScheduleId: uuidWithoutLine(),
            customerId: this.customerId,
            name: "日时段1",
            startDate: null,
            endDate: null,
            sort: 1,
            chargingPriceId: this.selectedChargingPrice.id,
            rateId: null,
            rates: [],
          }
          this.dailySchedule = dailySchedule
          this.dailySchedulesCache.push(dailySchedule)
          var dailySchedules = [dailySchedule]
          this.dailySchedulesArr.push(dailySchedules)
        }
        if(this.yearRanges.length === 0) {
          var yearRange = {
            id: uuidWithoutLine(),
            yearRangeId: uuidWithoutLine(),
            customerId: this.customerId,
            name: "年时区1",
            startDate: null,
            endDate: null,
            dailyScheduleId: null,
            chargingPriceId: this.selectedChargingPrice.id,
            sort: 1,
            dailySchedules: []
          }
          this.yearRange = yearRange
          this.yearRanges.push(yearRange)
        }
        this.detailDialogVisible = true
      },
      rateAdd: function(){
        if(this.rates.length === 4){
          Message({
            message: '基础费率最多设置4个',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        var length = this.rates.length +1
        var rateName = "费率" + length
        var rate = { id: uuidWithoutLine(), customerId: this.customerId, price: null, chargingPriceId: this.selectedChargingPrice.id, note: null }
        rate.name = rateName
        rate.sort = length
        this.rates.push(rate)
      },
      rateRemove: function(){
        this.rates.pop()
      },
      dailyScheduleAdd: function(index){
        if(this.dailySchedulesArr[index].length === 14){
          Message({
            message: '一个日时段最多设置14个小段',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        var length = this.dailySchedulesArr[index].length +1
        var num = index + 1
        var dailyScheduleName = '日时段' + num
        var dailyScheduleId = this.dailySchedulesArr[index][0].dailyScheduleId
        if(typeof dailyScheduleId === 'undefined' && dailyScheduleId === null && dailyScheduleId === ''){
          dailyScheduleId = uuidWithoutLine()
        }
        var dailySchedule = {
          id: uuidWithoutLine(),
          dailyScheduleId: dailyScheduleId,
          customerId: this.customerId,
          name: dailyScheduleName,
          startDate: null,
          endDate: null,
          sort: length,
          chargingPriceId: this.selectedChargingPrice.id,
          rateId: null,
          rates: [] }
        this.dailySchedulesArr[index].push(dailySchedule)
      },
      dailyScheduleRemove: function(index){
        this.dailySchedulesArr[index].pop()
      },
      dailySchedulesAdd: function(){
        if(this.dailySchedulesArr.length === 14){
          Message({
            message: '日时段最多设置14个',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        var length = this.dailySchedulesArr.length +1
        var dailyScheduleId = uuidWithoutLine()
        var dailyScheduleName = '日时段' + length
        var dailySchedule = {
          id: uuidWithoutLine(),
          dailyScheduleId: dailyScheduleId,
          customerId: this.customerId,
          name: dailyScheduleName,
          startDate: null,
          endDate: null,
          sort: 1,
          chargingPriceId: this.selectedChargingPrice.id,
          rateId: null,
          rates: []
        }
        var dailySchedules = [dailySchedule]
        this.dailySchedulesCache.push(dailySchedule)
        this.dailySchedulesArr.push(dailySchedules)
      },
      dailySchedulesRemove: function(){
        this.dailySchedulesCache.pop()
        this.dailySchedulesArr.pop()
      },
      yearRangeAdd: function(no){
        if(this.yearRanges.length === 14){
          Message({
            message: '年时区最多设置14个',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        var length = this.yearRanges.length + 1
        var yearRangeId = this.yearRanges[0].yearRangeId
        if(typeof yearRangeId === 'undefined' && yearRangeId === null && yearRangeId === ''){
          yearRangeId = uuidWithoutLine()
        }
        var yearRangeName = "年时区" + length
        var yearRange = {
          id: uuidWithoutLine(),
          yearRangeId: yearRangeId,
          customerId: this.customerId,
          name: yearRangeName,
          startDate: null,
          endDate: null,
          dailyScheduleId: null,
          chargingPriceId: this.selectedChargingPrice.id,
          sort: length,
          dailySchedules: []
        }
        this.yearRanges.push(yearRange)
      },
      yearRangeRemove: function(no){
        this.yearRanges.pop()
      },
      weekendAdd: function(no){
        if(this.weekends.length === 7){
          Message({
            message: '周休日最多设置7个',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        var length = this.weekends.length +1
        var weekendId = null
        if(no === -1){
          weekendId = uuidWithoutLine()
        }else{
          weekendId = this.weekends[0].weekendId
        }
        if(typeof weekendId === 'undefined' && weekendId === null && weekendId === ''){
          weekendId = uuidWithoutLine()
        }
        var weekendName = "周休" + length
        var weekend = {
          id: uuidWithoutLine(),
          weekendId: weekendId,
          customerId: this.customerId,
          name: weekendName,
          dayOfWeek: length,
          dailyScheduleId: null,
          chargingPriceId: this.selectedChargingPrice.id,
          dailySchedules: []
        }
        this.weekends.push(weekend)
      },
      weekendRemove: function(no){
        this.weekends.pop()
      },
      holidayAdd: function(no){
        if(this.holidays.length === 30){
          Message({
            message: '假节日最多设置30个',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        var length = this.holidays.length +1
        var holidayId = null
        if(no === -1){
          holidayId = uuidWithoutLine()
        }else{
          holidayId = this.holidays[0].holidayId
        }
        if(typeof holidayId === 'undefined' && holidayId === null && holidayId === ''){
          holidayId = uuidWithoutLine()
        }
        var holidayName = "节假日" + length
        var holiday = {
          id: uuidWithoutLine(),
          holidayId: holidayId,
          customerId: this.customerId,
          name: holidayName,
          date: new Date(new Date(new Date().toLocaleDateString()).getTime()),
          dailyScheduleId: null,
          chargingPriceId: this.selectedChargingPrice.id,
          dailySchedules: []
        }
        this.holidays.push(holiday)
      },
      holidayRemove: function(no){
        this.holidays.pop()
      },
      startTimeSetting: function(index,num){
        if(num === 0){
          this.dailySchedulesArr[index][num].startDate = new Date(new Date(new Date().toLocaleDateString()).getTime())//当前日期00:00:00
          Message({
            message: '第一段开始时间必须为00:00',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        var startDate = this.dailySchedulesArr[index][num].startDate
        this.dailySchedulesArr[index][num - 1].endDate = startDate
        if(this.dailySchedulesArr[index][num].startDate.getTime() >= this.dailySchedulesArr[index][num].endDate.getTime() ){
          Message({
            message: '开始时间不得大于结束时间',
            type: 'warning',
            duration: 5 * 1000
          })
          this.dailySchedulesArr[index][num - 1].endDate = null
          this.dailySchedulesArr[index][num].startDate = null
          return
        }
        if(this.dailySchedulesArr[index][num - 1].startDate.getTime() >= this.dailySchedulesArr[index][num - 1].endDate.getTime()){
          Message({
            message: '开始时间不得大于结束时间',
            type: 'warning',
            duration: 5 * 1000
          })
          this.dailySchedulesArr[index][num - 1].endDate = null
          this.dailySchedulesArr[index][num].startDate = null
          return
        }
      },
      endTimeSetting: function(index,num){
        if(this.dailySchedulesArr[index].length - 1 === num){
          this.dailySchedulesArr[index][num].endDate = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)//当前日期23:59:59
          Message({
            message: '最后一段结束时间必须为23:59',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        var endDate = this.dailySchedulesArr[index][num].endDate
        this.dailySchedulesArr[index][num + 1].startDate = endDate
        if(this.dailySchedulesArr[index][num].startDate.getTime() >= this.dailySchedulesArr[index][num].endDate.getTime()){
          Message({
            message: '开始时间不得大于结束时间',
            type: 'warning',
            duration: 5 * 1000
          })
          this.dailySchedulesArr[index][num].endDate = null
          this.dailySchedulesArr[index][num + 1].startDate = null
          return
        }
        if(this.dailySchedulesArr[index][num + 1].startDate.getTime() >= this.dailySchedulesArr[index][num + 1].endDate.getTime()){
          Message({
            message: '开始时间不得大于结束时间',
            type: 'warning',
            duration: 5 * 1000
          })
          this.dailySchedulesArr[index][num].endDate = null
          this.dailySchedulesArr[index][num + 1].startDate = null
          return
        }
      },
      startDateSetting: function(index){
        if(index === 0){
          this.yearRanges[index].startDate = new Date(getYearStartDate())
          Message({
            message: '第一段开始日期必须为1月1日',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        if(this.yearRanges[index].startDate.getMonth() === 0 && this.yearRanges[index].startDate.getDate() === 1){
          this.yearRanges[index].startDate = null
          Message({
            message: '非第一段开始日期不能为1月1日',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        var startDate = this.yearRanges[index].startDate
        var temp = new Date(startDate.getTime())
        temp.setDate(temp.getDate() - 1)
        this.yearRanges[index - 1].endDate = temp
        if(this.yearRanges[index].startDate.getTime() >=this.yearRanges[index].endDate.getTime() || this.yearRanges[index -1].startDate.getTime() >= this.yearRanges[index -1].endDate.getTime()){
          Message({
            message: '开始时间不得大于结束时间',
            type: 'warning',
            duration: 5 * 1000
          })
          this.yearRanges[index - 1].endDate = null
          this.yearRanges[index].startDate = null
        }
      },
      endDateSetting: function(index){
        if(this.yearRanges.length - 1 === index){
          this.yearRanges[index].endDate = new Date(getYearEndDate())
          Message({
            message: '最后一段结束日期必须为12月31日',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        if(this.yearRanges[index].endDate.getMonth() === 11 && this.yearRanges[index].endDate.getDate() === 31){
          this.yearRanges[index].endDate = null
          Message({
            message: '非最后一段结束日期不能为12月31日',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        var endDate = this.yearRanges[index].endDate
        var temp = new Date(endDate.getTime())
        temp.setDate(endDate.getDate() + 1)
        this.yearRanges[index + 1].startDate = temp
        if(this.yearRanges[index].startDate.getTime() >= this.yearRanges[index].endDate.getTime() || this.yearRanges[index + 1].startDate.getTime() >= this.yearRanges[index + 1].endDate.getTime()){
          Message({
            message: '开始时间不得大于结束时间',
            type: 'warning',
            duration: 5 * 1000
          })
          this.yearRanges[index].endDate = null
          this.yearRanges[index + 1].startDate = null
        }
      },
      chargingConfirm: function(){
        for(var i = 0; i < this.dailySchedulesArr.length; i ++) {
          for (var j = 0; j < this.dailySchedulesArr[i].length; j++) {
            this.dailySchedulesArr[i][j].rates = []
          }
        }
        for(var i = 0; i < this.yearRanges.length; i ++){
          this.yearRanges[i].dailySchedules = []
        }
        for(var i = 0; i < this.weekends.length; i ++){
          this.weekends[i].dailySchedules = []
        }
        for(var i = 0; i < this.holidays.length; i ++){
          this.weekends[i].dailySchedules = []
        }
          for(var i = 0; i < this.dailySchedulesArr.length; i ++){
            for(var j = 0; j < this.dailySchedulesArr[i].length; j++){
              for(var k = 0; k < this.rates.length; k ++){
                if(!chargingRegex.test(this.rates[k].price)){
                  Message({
                    message: '请输入正确的费率',
                    type: 'warning',
                    duration: 5 * 1000
                  })
                  return
                }
                if(this.rates[k].id === this.dailySchedulesArr[i][j].rateId){
                  this.dailySchedulesArr[i][j].rates.push(this.rates[k])
                }
              }
            }
          }
          for(var i = 0; i < this.dailySchedulesArr.length; i ++){
            for(var j = 0; j < this.dailySchedulesArr[i].length; j++){
              if(typeof this.dailySchedulesArr[i][j].startDate === 'undefined' || this.dailySchedulesArr[i][j].startDate === null || this.dailySchedulesArr[i][j].startDate === ''){
                Message({
                  message: '日时段-开始时间-必填',
                  type: 'warning',
                  duration: 5 * 1000
                })
                return
              }
              if(typeof this.dailySchedulesArr[i][j].endDate === 'undefined' || this.dailySchedulesArr[i][j].endDate === null || this.dailySchedulesArr[i][j].endDate === ''){
                Message({
                  message: '日时段-结束时间-必填',
                  type: 'warning',
                  duration: 5 * 1000
                })
                return
              }
              if(typeof this.dailySchedulesArr[i][j].rateId === 'undefined' || this.dailySchedulesArr[i][j].rateId === null || this.dailySchedulesArr[i][j].rateId === ''){
                Message({
                  message: '日时段-费率-必选',
                  type: 'warning',
                  duration: 5 * 1000
                })
                return
              }
              for(var k = 0; k < this.yearRanges.length; k ++){
                if(typeof this.yearRanges[k].startDate === 'undefined' || this.yearRanges[k].startDate === null || this.yearRanges[k].startDate === ''){
                  Message({
                    message: '年时区-开始时间-必填',
                    type: 'warning',
                    duration: 5 * 1000
                  })
                  return
                }
                if(typeof this.yearRanges[k].endDate === 'undefined' || this.yearRanges[k].endDate === null || this.yearRanges[k].endDate === ''){
                  Message({
                    message: '年时区-结束时间-必填',
                    type: 'warning',
                    duration: 5 * 1000
                  })
                  return
                }
                if(typeof this.yearRanges[k].dailyScheduleId === 'undefined' || this.yearRanges[k].dailyScheduleId === null || this.yearRanges[k].dailyScheduleId === ''){
                  Message({
                    message: '年时区-日时段-必选',
                    type: 'warning',
                    duration: 5 * 1000
                  })
                  return
                }
                if(this.yearRanges[k].dailyScheduleId === this.dailySchedulesArr[i][j].dailyScheduleId){
                  this.yearRanges[k].dailySchedules.push(this.dailySchedulesArr[i][j])
                  this.selectedChargingPrice.yearRangeId = this.yearRanges[k].yearRangeId
                }
              }
              var weekendMap = new Map()
              for(var m = 0; m < this.weekends.length; m ++){
                if(typeof this.weekends[m].dailyScheduleId === 'undefined' || this.weekends[m].dailyScheduleId === null || this.weekends[m].dailyScheduleId === ''){
                  Message({
                    message: '周休日-日时段-必选',
                    type: 'warning',
                    duration: 5 * 1000
                  })
                  return
                }
                weekendMap.set(this.weekends[m].dayOfWeek,this.weekends[m].dayOfWeek)
                if(this.weekends[m].dailyScheduleId === this.dailySchedulesArr[i][j].dailyScheduleId){
                  this.weekends[m].dailySchedules.push(this.dailySchedulesArr[i][j])
                  this.selectedChargingPrice.weekendId = this.weekends[m].weekendId
                }
              }
              if(weekendMap.size !== this.weekends.length){
                Message({
                  message:'周休日不可重复设置',
                  type: 'warning',
                  duration: 5 * 1000
                })
                return
              }
              var holidayMap = new Map()
              for(var n = 0; n < this.holidays.length; n ++){
                if(typeof this.holidays[n].date === 'undefined' || this.holidays[n].date === null || this.holidays[n].date === ''){
                  Message({
                    message: '节假日-日期-必填',
                    type: 'warning',
                    duration: 5 * 1000
                  })
                  return
                }
                if(typeof this.holidays[n].dailyScheduleId === 'undefined' || this.holidays[n].dailyScheduleId === null || this.holidays[n].dailyScheduleId === ''){
                  Message({
                    message: '节假日-日时段-必选',
                    type: 'warning',
                    duration: 5 * 1000
                  })
                  return
                }
                holidayMap.set(this.holidays[n].date.toString(), this.holidays[n].date)
                if(this.holidays[n].dailyScheduleId === this.dailySchedulesArr[i][j].dailyScheduleId){
                  this.holidays[n].dailySchedules.push(this.dailySchedulesArr[i][j])
                  this.selectedChargingPrice.holidayId = this.holidays[n].holidayId
                }
              }
              if(holidayMap.size !== this.holidays.length){
                Message({
                  message:'节假日不可重复设置',
                  type: 'warning',
                  duration: 5 * 1000
                })
                return
              }
            }
          }
          this.detailDialogVisible = false
      },
      formatTime: function(time) {
        if (typeof time !== undefined && time !== null) {
          return formatToSecond(time)
        } else {
          return time
        }
      },
      isNumber(val){

        var regPos = /^\d+(\.\d+)?$/; //非负浮点数
        var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
        if(regPos.test(val) || regNeg.test(val)){
          return true;
        }else{
          return false;
        }

      },
      numberFormat4: function(value){
        value = Math.round(value * Math.pow(10, 4)) / Math.pow(10, 4); //四舍五入
        value = Number(value).toFixed(4); //补足位数
        return value;

      },
      add: function() {
        this.selectedChargingPrice = null//重置
        var customerId = this.customerId
        getCustomerEenrgies(customerId).then(res => {
          if(res.code === 200){
            this.customerEnergies =  res.infoJson
          }
        })
        this.selectedChargingPrice = { id: uuidWithoutLine(), customerId: this.customerId, name: null, code: null, customerEnergyId: null,
          type: 1, singlePrice: null, yearRangeId: null, holidayId: null, weekendId: null, startDate: new Date(), note: null,
          yearRanges: [], weekends: [], holidays: []}
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
        this.dialogVisible = true
      },
      edit: function(){
        if (typeof this.selectedChargingPrice.id === 'undefined' || this.selectedChargingPrice.id === null || this.selectedChargingPrice.id === '') {
          Message({
            message: '请选择计费价格',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
        this.dialogVisible = true
      },
      remove: function(){
        if (typeof this.selectedChargingPrice.id === 'undefined' || this.selectedChargingPrice.id === null || this.selectedChargingPrice.id === '') {
          Message({
            message: '请选择计费价格',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        this.removeDialogVisible = true
      },
      deleteChargingPrice: function(){
        const chargingPriceId = this.selectedChargingPrice.id
        remove(chargingPriceId).then(res =>{
          if (res.code === 200){
            Message({
              message: '操作成功',
              type: 'success',
              duration: 5 * 1000
            })
          } else{
            Message({
              message: res.message,
              type: 'warning',
              duration: 5 * 1000
            })
          }
          this.removeDialogVisible = false
          this.fetchChargingPrice()
          this.selectedChargingPrice = {}
        })
      },
      handleSizeChange: function(size) {
        this.page.size = size
        this.page.current = 1
        this.fetchChargingPrice()
      },
      handleCurrentChange: function(currentPage) {
        this.page.current = currentPage
        this.fetchChargingPrice()
      },
      save: function () {

        this.$refs.form.validate(valid => {
          if (valid) {
            if(this.selectedChargingPrice.type === 1 && (this.selectedChargingPrice.singlePrice === null || this.selectedChargingPrice.singlePrice.length === 0)){
              Message({
                message: '请输入单一电价',
                type: 'warning',
                duration: 5 * 1000
              })
              return
            }
            verifyChargingPrice(this.selectedChargingPrice).then(res => {
              if (res.code === 200) {
                if (res.infoJson) {
                  save(this.selectedChargingPrice).then(res =>{
                    if (res.code === 200){
                      Message({
                        message: '操作成功',
                        type: 'success',
                        duration: 5 * 1000
                      })
                      this.dialogVisible = false
                      this.fetchChargingPrice()
                      this.selectedChargingPrice = {}
                    } else{
                      Message({
                        message: this.selectedChargingPrice.type === 1 ? '单一费率设置错误' : '分时费率未设置或设置错误',
                        type: 'warning',
                        duration: 5 * 1000
                      })
                    }
                  })
                } else {
                  Message({
                    message: '计费价格编码已存在',
                    type: 'warning',
                    duration: 5 * 1000
                  })
                }
              }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      detailView: function (currentChargingPrice) {
        //重置
        this.rates = []
        this.dailySchedulesCache = []
        this.dailySchedulesArr = []
        this.yearRanges = []
        this.weekends = []
        this.holidays = []
        //获取年时区、节假日、周休日中的日时段信息（去重）
        var nameAndIds = [];//去重用
        var dailSchedulesTemp = [];
        if(currentChargingPrice.yearRanges.length>0){
          for(var i = 0; i < currentChargingPrice.yearRanges.length; i ++){
            if(currentChargingPrice.yearRanges[i].dailySchedules.length > 0){
              for(var j = 0; j < currentChargingPrice.yearRanges[i].dailySchedules.length; j ++){
                if(nameAndIds.indexOf(currentChargingPrice.yearRanges[i].dailySchedules[j].name+','+
                  currentChargingPrice.yearRanges[i].dailySchedules[j].id) === -1){
                  nameAndIds.push(currentChargingPrice.yearRanges[i].dailySchedules[j].name+','+
                    currentChargingPrice.yearRanges[i].dailySchedules[j].id)
                  dailSchedulesTemp.push(currentChargingPrice.yearRanges[i].dailySchedules[j])
                }
              }
            }
          }
        }
        if(currentChargingPrice.weekends.length>0){
          for(var i = 0; i < currentChargingPrice.weekends.length; i ++){
            if(currentChargingPrice.weekends[i].dailySchedules.length > 0){
              for(var j = 0; j < currentChargingPrice.weekends[i].dailySchedules.length; j ++){
                if(nameAndIds.indexOf(currentChargingPrice.weekends[i].dailySchedules[j].name+','+
                  currentChargingPrice.weekends[i].dailySchedules[j].id) === -1){
                  nameAndIds.push(currentChargingPrice.weekends[i].dailySchedules[j].name+','+
                    currentChargingPrice.weekends[i].dailySchedules[j].id)
                  dailSchedulesTemp.push(currentChargingPrice.weekends[i].dailySchedules[j])
                }
              }
            }
          }
        }
        if(currentChargingPrice.holidays.length>0){
          for(var i = 0; i < currentChargingPrice.holidays.length; i ++){
            if(currentChargingPrice.holidays[i].dailySchedules.length > 0){
              for(var j = 0; j < currentChargingPrice.holidays[i].dailySchedules.length; j ++){
                if(nameAndIds.indexOf(currentChargingPrice.holidays[i].dailySchedules[j].name+','+
                  currentChargingPrice.holidays[i].dailySchedules[j].id) === -1){
                  nameAndIds.push(currentChargingPrice.holidays[i].dailySchedules[j].name+','+
                    currentChargingPrice.holidays[i].dailySchedules[j].id)
                  dailSchedulesTemp.push(currentChargingPrice.holidays[i].dailySchedules[j])
                }
              }
            }
          }
        }
        //划分日时段
        var names = [];
        if(nameAndIds.length > 0){
          for(var i = 0; i < nameAndIds.length; i ++){
            if(names.indexOf(nameAndIds[i].split(',')[0]) === -1){
              names.push(nameAndIds[i].split(',')[0])
            }
          }
        }
        var dailySchedulesArrTemp = []
        if(names.length > 0){
          for(var i = 0; i < names.length; i ++){
            if(dailSchedulesTemp.length > 0){
              var dailySchedulesTmep1 = []
              for(var j = 0; j < dailSchedulesTemp.length; j ++){
                if(dailSchedulesTemp[j].name === names[i]){
                  dailySchedulesTmep1.push(dailSchedulesTemp[j])
                }
              }
              dailySchedulesArrTemp.push(dailySchedulesTmep1)
            }
          }
        }
        //获取日时段中所有的基本费率信息（去重）
        var rateIds = []//去重用
        var ratesTemp = []
        if(dailSchedulesTemp.length > 0){
          for(var j = 0; j < dailSchedulesTemp.length; j ++){
            if(dailSchedulesTemp[j].rates.length > 0){
              for(var i = 0 ; i < dailSchedulesTemp[j].rates.length; i ++){
                dailSchedulesTemp[j].rates[i].price = this.numberFormat4(dailSchedulesTemp[j].rates[i].price)
                if(rateIds.indexOf(dailSchedulesTemp[j].rates[i].id) === -1){
                  rateIds.push(dailSchedulesTemp[j].rates[i].id)
                  ratesTemp.push(dailSchedulesTemp[j].rates[i])
                }
              }
            }
          }
        }
        //划分日时段缓存
        var dscIds = []
        var dailySchedulesCacheTemp = []
        if(dailSchedulesTemp.length>0){
          for(var i = 0; i < dailSchedulesTemp.length; i ++){
            if(currentChargingPrice.yearRanges.length>0){
              for(var j = 0; j < currentChargingPrice.yearRanges.length; j ++){
                if(currentChargingPrice.yearRanges[j].dailyScheduleId === dailSchedulesTemp[i].dailyScheduleId){
                  if(dscIds.indexOf(currentChargingPrice.yearRanges[j].dailyScheduleId) === -1){
                    dscIds.push(currentChargingPrice.yearRanges[j].dailyScheduleId)
                    dailySchedulesCacheTemp.push(dailSchedulesTemp[i])
                  }
                }
              }
            }
            if(currentChargingPrice.weekends.length>0){
              for(var j = 0; j < currentChargingPrice.weekends.length; j ++){
                for(var k = 0; k < currentChargingPrice.weekends[j].dailySchedules.length; k ++){
                  if(currentChargingPrice.weekends[j].dailyScheduleId === dailSchedulesTemp[i].dailyScheduleId){
                    if(dscIds.indexOf(currentChargingPrice.weekends[j].dailyScheduleId) === -1){
                      dscIds.push(currentChargingPrice.weekends[j].dailyScheduleId)
                      dailySchedulesCacheTemp.push(dailSchedulesTemp[i])
                    }
                  }
                }
              }
            }
            if(currentChargingPrice.holidays.length>0){
              for(var j = 0; j < currentChargingPrice.holidays.length; j ++){
                for(var k = 0; k < currentChargingPrice.holidays[j].dailySchedules.length; k ++){
                  if(currentChargingPrice.holidays[j].dailyScheduleId === dailSchedulesTemp[i].dailyScheduleId){
                    if(dscIds.indexOf(currentChargingPrice.holidays[j].dailyScheduleId) === -1){
                      dscIds.push(currentChargingPrice.holidays[j].dailyScheduleId)
                      dailySchedulesCacheTemp.push(dailSchedulesTemp[i])
                    }
                  }
                }
              }
            }
          }
        }
        //修改信息预填
        this.rates = ratesTemp
        this.dailySchedulesCache = dailySchedulesCacheTemp
        this.dailySchedulesArr = dailySchedulesArrTemp
        this.yearRanges = currentChargingPrice.yearRanges
        this.weekends = currentChargingPrice.weekends
        this.holidays = currentChargingPrice.holidays
        this.viewDialogVisible = true
      }
    }

  }
</script>
<style scoped rel="stylesheet/scss" lang="scss">
    .chargingPrice-config-page-box {
        height: 2.8125rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .chargingPrice-config-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        button {
            /*font-size: 14px;*/
            font-weight: bold;
        }
        .head{
            flex-direction: column;
            box-sizing: border-box;
            .collection-manage-condition-box{
                font-size: 0.875rem;
                display: flex;
                align-items: center;
                padding-top: 1%;
                padding-left: 2%;
                box-sizing: border-box;

            }
            .op-box {
                padding-left: 2%;
                padding-top: 1%;
                padding-bottom: 15px;
                /*padding-left: 1%;

                padding-bottom: 15px;*/
            }
        }
        .chargingPrice-config-table-box {
            /* overflow: auto;
             max-height: 320px;
             height: auto;
             width: auto;
             display: block;
             align-items: center;*/
            flex: 4;

        }



        .el-table .warning-row {
            background: oldlace;
        }

        .div-hr {
            height: 1px;
            background-color: #dedede;
        }
    }

    ::-webkit-scrollbar { /*滚动条整体样式*/
        width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 6px;
    }

    ::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(210, 210, 210, 210);
        background: rgba(210, 210, 210, 210);
    }

    ::-webkit-scrollbar-track { /*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 255);
        border-radius: 0;
        background: rgba(255, 255, 255, 255);
    }
</style>
<style>
    .el-dialog {
        background: #f6f7f7 !important;
    }
</style>
